import { useEffect, useEffectEvent, useState } from 'react'
import { listMembers } from '../application/list-members'
import type { Member } from '../domain/workflow'
import { workflows as workflowsPort, notify } from '../wiring'

// Members of the team that owns the work item's current phase - the pool an item
// can be assigned to (phase-team or management, enforced later via the seam).
// Workflows-owned lookup over its own mirage-backed port; never imports the
// PocketBase-wired members feature. Mirrors the customer-lookup isolation.
const useMemberLookup = (teamId: string | null) => {
	const [members, setMembers] = useState<Member[]>([])

	const load = useEffectEvent(async (id: string) => {
		const result = await listMembers(workflowsPort, id, notify)
		setMembers(result)
	})

	useEffect(() => {
		if (!teamId) {
			setMembers([])
			return
		}
		load(teamId)
	}, [teamId])

	return { members }
}

export { useMemberLookup }
